import QRCode, { QRCodeCanvas } from "qrcode.react";
import React, { useEffect, useRef, useState } from "react";

const ReferQrcode = ({ value }) => {
  const qrRef = useRef(null);
  const [imgSrc, setImgSrc] = useState("");
  useEffect(() => {
    if (qrRef.current) {
      const canvas = qrRef.current.children[0];
      const image = canvas.toDataURL("image/png");
      setImgSrc(image);
    }
  }, [value]);
  return (
    <div>
      <div className="hidden" ref={qrRef}>
        <QRCodeCanvas value={value} />
      </div>
      {imgSrc && (
        <img
          className="w-[128px] h-[128px] img-can-select"
          src={imgSrc}
          alt="QR Code"
        />
      )}
    </div>
  );
};

export default ReferQrcode;
